module.exports = __webpack_public_path__ + "static/img/6.6ca7419.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/14/zh/6.png
// module id = FiYi
// module chunks = 0